import { render, staticRenderFns } from "./AccountExpiryBanner.vue?vue&type=template&id=75cbb8bf&"
import script from "./AccountExpiryBanner.vue?vue&type=script&lang=js&"
export * from "./AccountExpiryBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports